import { Box, Typography } from "@mui/material";
import type { ReactElement, ReactNode } from "react";

import { AppDialogBackButton } from "./AppDialogBackButton.tsx";
import { useAppDialogTitleId } from "./appDialogTitleId.context.tsx";

type Props = {
  variant?: "h1" | "h3";
  subheading?: ReactNode;
  onBack?: () => void;
  children: ReactNode;
};

/** The title `id` claims the id `AppDialog` reserved; without it the dialog has no accessible name. */
export function AppDialogHeader({
  variant = "h1",
  subheading,
  onBack,
  children,
}: Props): ReactElement {
  const titleId = useAppDialogTitleId();

  return (
    <Box sx={{ p: (theme) => theme.spacing(4, 9, 2, 4) }}>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          alignItems: "center",
          pb: subheading ? 0.5 : 0,
        }}
      >
        {onBack && <AppDialogBackButton onClick={onBack} />}
        <Typography
          id={titleId}
          variant={variant}
          sx={{ overflowWrap: "break-word", minWidth: 0 }}
        >
          {children}
        </Typography>
      </Box>
      {subheading && (
        <Typography variant="body3" sx={{ overflowWrap: "break-word" }}>
          {subheading}
        </Typography>
      )}
    </Box>
  );
}
